var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app","dark":""}},[_c('div',{staticClass:"appContent"},[_c('TitleBar',{staticClass:"titleBar"}),_c('SocialMediaBar',{staticClass:"socialMediaBar"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }